<template>
  <div>
    <v-row no-gutters class="ma-0">
      <v-col cols="12" v-if="isHeader">
        <v-card
          elevation="0"
          class="list-box-Shadow"
          :class="title ? 'pa-4' : ''"
        >
          <v-row no-gutters>
            <v-col cols="6" class="d-flex align-center justify-start">
              <PrimaryButton
                class="btn-box mr-4"
                @click="$router.back()"
                icon="mdi-arrow-left-bold"
                iconSize="18"
                iconClass="ma-0"
              >
              </PrimaryButton>
              <h4 class="font-weight-bold text_color--text">
                {{ title }}
              </h4>
            </v-col>
            <v-col cols="6" class="d-flex justify-end">
              <slot name="actions" />
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col
        cols="12"
        v-if="nonFieldErrors && nonFieldErrors.length > 0"
        class="pt-0"
      >
        <v-alert dense type="error" class="ma-0">
          <v-list
            class="pa-0"
            dense
            style="background: inherit !important"
            v-for="(error, i) in nonFieldErrors"
            :key="i"
          >
            <v-list-item dense style="min-height: 20px !important">
              <span>{{ i }} .</span><span>{{ error }}</span>
            </v-list-item>
          </v-list>
        </v-alert>
      </v-col>
      <v-col
        cols="12"
        class="overflow-y-auto overflow-x-hidden"
        :style="{ height: customHeight }"
        :class="contentClass"
      >
        <slot name="content" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    customHeight: {
      default: "calc(100vh - 130px)",
    },
    isHeader: {
      type: Boolean,
      default: true,
    },
    contentClass: {
      type: String,
      default: "pa-4",
    },
    nonFieldErrors: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style></style>
